import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const Edit = () => {
    document.title = "Redaktə et";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Redaktə et", value: "/products/parameters/edit", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Redaktə et</h2>
                    <p>
                        Məhsullar ilə əməliyyatlar zamanı kütləvi dəyişiklik etmək üçün <Button>Redaktə et</Button> düyməsindən istifadə etmək olar. Nümunədə
                        bir neçə məhsulun eyni anda qrupunu dəyişmək göstərilib. Qrup adınin üzərinə tıklayıb, həmin qrupdakı bütün məhsulları seçib,
                        <Button>Redaktə et</Button> düyməsini sıxmaq lazımdır. Açılmış pəncərədə kütləvi dəyişiklik etmək istədiyiniz seçim edilir. Daha sonra
                        seçimə uyğun olan dəyişiklik olunur və <SaveButton /> düyməsi sıxılır.
                    </p>
                    <img src="/images/products/parameters/edit.gif" alt="Redaktə et" />
                </article>
            </div>
        </div>
    );
};
